<script>
  /**
   * About component
   */
  export default {
    name: 'About',
  }
</script>

<template>
  <!--START ABOUT-US-->
  <section class="" id="about">
    <!--<div class="">
      <section
        class="section bg-web-desc"
        :style="{
          'background-image': 'url(' + require('@/assets/images/banner.5.png') + ')',
          'background-size': 'cover',
          'background-position': 'center',
        }"
      >
        <div class="bg-overlay"></div>
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <h2 class="text-white">Expandimos nuestro negocio a TODO Uruguay </h2>
              <p class="padding-t-15 home-desc mx-auto">
                Si te encuentras en las principales ciudades del país y estás buscando tu
                oportunidad de inversión, este negocio es para ti<br />
                <br />
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>-->
  </section>
  <!--END ABOUT-US-->
</template>
